import { createFileRoute } from '@tanstack/react-router';
import { ByProjectView } from '@/features/timesheet/ByProjectView';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileTimesheetByProject } from '@/features/timesheet/mobile/MobileTimesheetByProject';

export const Route = createFileRoute('/_app/timesheet/by-project')({ component: TimesheetByProjectPage });

/** Selettore mobile/desktop: su telefono commessa e periodo si scelgono da fogli tappabili. */
function TimesheetByProjectPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileTimesheetByProject /> : <ByProjectView />;
}
